import type { OrganizationMembershipSummary } from '@cmoh/shared'
import { useApiQuery } from '@/hooks/use-api'
import { WITHOUT_TAB_ORGANIZATION } from '@/lib/axios'

const ORGANIZATION_MEMBERSHIPS_QUERY_KEY = ['organization-memberships'] as const
const ORGANIZATION_MEMBERSHIPS_URL = '/organization/memberships'

export function useOrganizationMemberships({ enabled }: { enabled: boolean }) {
  const { data, isLoading, error } = useApiQuery<OrganizationMembershipSummary[]>(
    ORGANIZATION_MEMBERSHIPS_QUERY_KEY,
    ORGANIZATION_MEMBERSHIPS_URL,
    WITHOUT_TAB_ORGANIZATION,
    { enabled },
  )

  return { memberships: data ?? [], isLoading, error }
}
